import * as Yup from 'yup';
import createTipoCotizacionFormModel from './createTipoCotizacionFormModel';

const {
  formField: {
    name,
    description
  }

} = createTipoCotizacionFormModel;


export default [

  Yup.object().shape({ 
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),    
    [description.name]: Yup.string().required(`${description.requiredErrorMsg}`),
  })
  
];  

    